/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash/get";

export const normalizeLinkHref = (href, internalHosts = "") => {
  if (!href) return href;
  if (typeof href !== "string") {
    return href;
  }
  if (
    href.startsWith("/") ||
    href.startsWith("#") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    href.startsWith("javascript:")
  ) {
    return href;
  }
  try {
    const url = new URL(href);
    const anchorHostname = url.hostname.replace(/^www\./, "");

    const hostList = Array.isArray(internalHosts) ? internalHosts : [internalHosts];
    const internalHostnames = new Set();
    hostList.forEach((host) => {
      if (!host || typeof host !== "string") return;
      try {
        const parsed = (host.includes("://") ? new URL(host).hostname : host).replace(/^www\./, "");
        if (parsed) internalHostnames.add(parsed);
      } catch (e) { }
    });

    const currentHostname =
      typeof window !== "undefined" && window.location?.hostname
        ? window.location.hostname.replace(/^www\./, "")
        : "";
    if (currentHostname) {
      internalHostnames.add(currentHostname);
    }

    if (internalHostnames.has(anchorHostname)) {
      return `${url.pathname}${url.search}${url.hash}`;
    }

    return href;
  } catch (e) {
    return href;
  }
};

export const CustomLinkBase = (props) => {
  const { itemType, href = "", ...restProps } = props;
  const sketchesHost = useSelector((state) => get(state, ["qt", "config", "sketches-host"], ""));
  const currentHostUrl = useSelector((state) => get(state, ["qt", "currentHostUrl"], ""));
  const _href = props.href === null ? null : normalizeLinkHref(href, [sketchesHost, currentHostUrl]);
  const customCallback = () => {
    props.callback && props.callback();
    props.closeAll();
  };
  // Set to true so Link navigations do not trigger PAGE_LOADING (the black loading screen).
  const disableAjaxLinks = true;
  return <Link href={_href} {...restProps} callback={customCallback} disableAjaxLinks={disableAjaxLinks} />;
};

const mapDispatchToProps = (dispatch) => ({
  closeAll: () => dispatch({ type: "CLOSE_ALL" }),
});

export const CustomLink = connect(() => ({}), mapDispatchToProps)(CustomLinkBase);

CustomLinkBase.propTypes = {
  closeAll: PropTypes.func,
  callback: PropTypes.func,
  itemType: PropTypes.string,
};
